import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretRight } from "@fortawesome/free-solid-svg-icons";

const FaCareRight = () => {
  return <FontAwesomeIcon icon={faCaretRight} />;
};

export default FaCareRight;
